// Automatically generated from TW.Saga.Core.Base, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @30.07.2019 15:26:36
import { PersistentObject } from '../../SagaBase/PersistentObject';
import * as SagaBase from '../../SagaBase';
import { Guid, GuidTools } from '@models/guid';

export abstract class Sector_abstract extends PersistentObject {
  static $t: string = 'SagaBase.Sector';
  $t: string = 'SagaBase.Sector';

  public static GetMembers(): string[] {
    return [
      'ResourcePriority',
      'Deleted',
      'GeoSectorUid',
      'GeoSectorId',
      'GeoSectorParentId',
      'GeoSectorType',
      'TreeTypeId',
      'Name',
      'Left',
      'Right',
      'CoordX',
      'CoordY',
      'Color'
    ].concat(PersistentObject.GetMembers());
  }

  public GetMembers(): string[] {
    return Sector_abstract.GetMembers();
  }

  public _init(): void {
    super._init();
    //// Add "NO-" before "AUTO_INIT_CODE" if don't want to re-generate at each compilation
    ///*<AUTO_INIT_CODE>*/

    ///*</AUTO_INIT_CODE>*/
  }

  // Add "NO-" before "INSTANCE_MEMBERS" if don't want to re-generate at each compilation
  /*<INSTANCE_MEMBERS>*/

  public ResourcePriority: number = 0;
  public Deleted: boolean = false;
  public GeoSectorUid: Guid = GuidTools.Empty;
  public GeoSectorId: number = 0;
  public GeoSectorParentId: number;
  public GeoSectorType: number = 0;
  public TreeTypeId: number = 0;
  public Name: string;
  public Left: number = 0;
  public Right: number = 0;
  public CoordX: number;
  public CoordY: number;
  public Color: string;

  /*</INSTANCE_MEMBERS>*/

  // Add "NO-" before "AUTO_IMPLEMENTATION" if don't want to re-generate at each compilation
  /*<AUTO_IMPLEMENTATION>*/

  get ObjId(): any {
    return this.GeoSectorId;
  }
  get ParentObjId(): any {
    return null;
  }
  set ParentObjId(value: any) {}

  /*</AUTO_IMPLEMENTATION>*/
}
